import { render, staticRenderFns } from "./contentCourseLearnerDelete.vue?vue&type=template&id=65d319b2&"
import script from "./contentCourseLearnerDelete.vue?vue&type=script&lang=js&"
export * from "./contentCourseLearnerDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports